<p-toast></p-toast>
<div class="layout-main">
  <div class="container-fluid">
    <div class="row">
      <div class="pb-2 mb-3 border-bottom col-12">
        <h2>
          <b>Documents available to download</b>
        </h2>
      </div>
    </div>
    <div *ngIf="loadError" class="alert alert-danger" role="alert">
      Unable to load documents right now. Please try again later.
    </div>
    <div *ngIf="error" class="alert alert-danger alert-dismissible fade show">
      An error occurred while processing your request.
      <button (click)="error = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div *ngIf="documentFileNotFound" class="alert alert-danger alert-dismissible fade show">
      File not found.
      <button (click)="documentFileNotFound = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div *ngIf="documentLinkError" class="alert alert-danger alert-dismissible fade show">
      This document doesn't exist or you don't have access to it.
      <button (click)="documentLinkError = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div *ngIf="notFoundError" class="alert alert-danger alert-dismissible fade show">
      File not found.
      <button (click)="notFoundError = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div *ngIf="errorExport" class="alert alert-danger alert-dismissible fade show">
      Error while trying to download file
      <button (click)="error = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div *ngIf="deleteDocumentAlert" class="alert alert-success alert-dismissible fade show">
      The document has been deleted successfully.
      <button (click)="deleteDocumentAlert = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div *ngIf="undeleteDocumentAlert" class="alert alert-success alert-dismissible fade show">
      The document has been undeleted successfully.
      <button (click)="undeleteDocumentAlert = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="row">
      <p-toast key="tl" position="top-left"></p-toast>
      <div class="col-12">
        <p-panel [toggleable]="true">
          <ng-template pTemplate="header">
            <span class="filter-title p-panel-title"><i class="fa fa-search"></i>Filter</span>
          </ng-template>
          <div class="row">
            <div class="col-4">
              <div class="row align-items-center">
                <div class="col-12">
                  <p-floatLabel>
                    <input
                      id="title"
                      pInputText
                      [(ngModel)]="documentFilterCriteria.title"
                      (ngModelChange)="filter()"
                      class="form-control w-100"
                      type="text"
                    />
                    <label for="title">Title</label>
                  </p-floatLabel>
                </div>
              </div>
            </div>
            <div class="col-8">
              <div class="row">
                <div *roles="['ROLE_MCKAY']" class="col-6">
                  <div class="row">
                    <div class="col-12">
                      <p-floatLabel>
                        <p-multiSelect
                          [options]="availableToOptions"
                          [(ngModel)]="documentFilterCriteria.availableTo"
                          (onChange)="filter()"
                          [maxSelectedLabels]="2"
                          optionLabel="label"
                          optionValue="value">
                        </p-multiSelect>
                        <label>Available to</label>
                      </p-floatLabel>
                    </div>
                  </div>
                </div>
                <div class="col-2" style="padding-top: 2rem !important;">
                  <p-checkbox [(ngModel)]="documentFilterCriteria.isNew" (ngModelChange)="filter()" binary="true"
                              label="Is New"></p-checkbox>
                </div>
                <div *roles="['ROLE_CLIENT']" class="col-2" style="padding-top: 2rem !important;">
                  <p-checkbox [(ngModel)]="documentFilterCriteria.watchedFiles" (ngModelChange)="filter()" binary="true"
                              label="Watched files"></p-checkbox>
                </div>
                <div *roles="['ROLE_MCKAY']" class="col-2" style="padding-top: 2rem !important;">
                </div>
                <div *roles="['ROLE_CLIENT']" class="col-6" style="padding-top: 2rem !important;">
                </div>
                <div class="col-2" style="padding-top: 2rem !important;">
                  <button (click)="reset()" class="pull-right" icon="fa fa-refresh pr-2" iconPos="left"
                          id="reset_button"
                          label="Reset" pButton type="button"></button>
                </div>
              </div>
            </div>
          </div>
          <div class="row align-items-center g-3">
            <div class="col-12">
              <p-floatLabel>
                <p-multiSelect
                  class="w-100"
                  [options]="tags"
                  [(ngModel)]="documentFilterCriteria.tags"
                  (onChange)="filter()"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select tags"
                  [filter]="true"
                  [display]="'chip'"
                  [maxSelectedLabels]="tags.length"
                  appendTo="body">
                </p-multiSelect>
                <label>Tags</label>
              </p-floatLabel>
            </div>
          </div>
        </p-panel>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <p-table #dataTable [columns]="cols" [paginator]="true" [rows]="30" [totalRecords]="size"
                 [value]="filteredDocumentsList"
                 id="documents-list-table">
          <ng-template *roles="['ROLE_MCKAY']" pTemplate="caption">
            <div class="p-helper-clearfix caption-buttons-container caption-buttons-container">
              <button (click)="toggleSubscription()" pButton class="float-right"
                      [icon]="isSubscribed ? 'fa fa-solid fa-bell-slash icon-color pr-2' : 'fa fa-solid fa-bell icon-color pr-2'"
                      iconPos="left">
                {{ isSubscribed ? 'Unsubscribe to weekly download report' : 'Subscribe to weekly download report' }}</button>
              <button (click)="exportAsExcel()" class="float-right" icon="fa fa-download pr-2" iconPos="left"
                      label="Export as XLS" pButton type="button"></button>
              <button (click)="showOrHideDocument()" *ngIf="!showDeletedDocuments" class="float-right"
                      icon="fa fa-eye pr-2"
                      iconPos="left" id="show-deleted-document"
                      label="Show Deleted Documents" pButton type="button"></button>
              <button (click)="showOrHideDocument()" *ngIf="showDeletedDocuments" class="float-right"
                      icon="fa fa-eye-slash pr-2"
                      iconPos="left" id="hide-deleted-document"
                      label="Hide Deleted Documents" pButton type="button"></button>
              <button class="float-right"
                      icon="fa fa-plus-circle pr-2" iconPos="left" id="add_document" label="New" pButton
                      routerLink="/document/new" type="button"></button>
            </div>
          </ng-template>
          <ng-template let-cols pTemplate="header">
            <tr>
              <th *ngFor="let col of cols" [pSortableColumn]="col.sortField || col.field" width="{{col.width}}">
                {{ col.header }}
                <p-sortIcon *ngIf="col.sortable" [field]="col.sortField || col.field"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template let-document pTemplate="body">
            <ng-container *ngIf="!document.deleted || showDeletedDocuments">
              <tr>
                <td style="word-wrap: break-word; max-width: 33%;">
                  <div [innerHTML]="document.title"></div>
                </td>
                <td style="height: 40px">
                  <div class="icon-container">
                    <a (click)="getDocumentByUniqid(document.uniqid)" class="btn btn-link"
                       style="font-size: 13px; text-align: left">{{ document.filename }}</a>
                    <i (click)="copyDocumentUrl(document.uniqid)" class="fa fa-copy"
                       style="color: #007bff;cursor: pointer;" title="Click to copy document link"></i>
                  </div>
                </td>
                <td>
                  {{ document.size }}
                </td>
                <td *roles="['ROLE_MCKAY']" style="min-width: 150px">
                  <div [innerHTML]="document.availableTo"></div>
                </td>
                <td>
                  {{ document.availableSince | date }}
                </td>
                <td>
                  {{ document.uploadedBy }}
                </td>
                <td *roles="['ROLE_MCKAY']">
                  <p-overlayPanel #opWatchers [dismissable]="true" [style]="{width: '15%'}" appendTo="body">
                    <ul style="padding-left: 15px;">
                      <li *ngFor="let watcher of watchersByDocument[document.id]">
                        {{ watcher }}
                      </li>
                    </ul>
                  </p-overlayPanel>
                  <a (click)="displayWatchersPopUp($event, opWatchers, document)" (close)="opWatchers.hide()"
                     style="color: #007bff">{{ document.nbOfWatchers }}</a>
                </td>
                <td *roles="['ROLE_MCKAY']">
                  <i *ngIf="document.monitorDownloads" class="fa fa-check"></i>
                  <i *ngIf="!document.monitorDownloads"></i>
                </td>
                <td class="action-width">
                  <div class="d-flex flex-column">
                    <ng-container *roles="['ROLE_CLIENT']">
                      <button (click)="watchDocument(document)" *ngIf="!watchedDocumentsList.includes(document.id)"
                              class="btn btn-link no-padding-button"
                              name="edit_user_link"
                              pTooltip="Register to receive alerts when this document is updated."
                              type="button">
                        <i aria-hidden="true" class="fa fa-eye icon-color"></i>
                        <span> Watch</span>
                      </button>
                      <button (click)="unwatchDocument(document)" *ngIf="watchedDocumentsList.includes(document.id)"
                              class="btn btn-link no-padding-button"
                              name="edit_user_link"
                              pTooltip="Unregister from alerts when this document is updated."
                              type="button">
                        <i aria-hidden="true" class="fa fa-eye-slash icon-color"></i>
                        <span> Unwatch</span>
                      </button>
                    </ng-container>
                    <ng-container *roles="['ROLE_MCKAY']">
                      <button (click)="redirectToDownloadLog(document)" class="btn btn-link no-padding-button"
                              name="edit_user_link"
                              type="button">
                        <i aria-hidden="true" class="fa fa-download icon-color"></i>
                        <span> Download log</span>
                      </button>
                      <ng-container *ngIf="!document.deleted && canEditOrDeleteDocument()">
                        <button (click)="editDocument(document)" class="btn btn-link no-padding-button"
                                name="edit_user_link"
                                type="button">
                          <i aria-hidden="true" class="fa fa-pencil icon-color"></i>
                          <span> Edit</span>
                        </button>
                      </ng-container>
                      <ng-container *ngIf="document.deleted || !canEditOrDeleteDocument()">
                        <button (click)="showDocument(document)" class="btn btn-link no-padding-button"
                                name="edit_user_link"
                                type="button">
                          <i aria-hidden="true" class="fa fa-eye icon-color"></i>
                          <span> Show</span>
                        </button>
                      </ng-container>
                      <ng-container *ngIf="!document.deleted && canEditOrDeleteDocument()">
                        <button (click)="deleteDocument(document)" class="btn btn-link no-padding-button"
                                name="delete_link"
                                type="button">
                          <i aria-hidden="true" class="fa fa-close icon-color"></i>
                          <span> Delete</span>
                        </button>
                      </ng-container>
                      <ng-container *ngIf="document.deleted && canEditOrDeleteDocument()">
                        <button (click)="undeleteDocument(document)" class="btn btn-link no-padding-button"
                                name="delete_link"
                                type="button">
                          <i aria-hidden="true" class="fa fa-undo icon-color"></i>
                          <span> Undelete</span>
                        </button>
                      </ng-container>

                    </ng-container>
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-template>
          <ng-template pTemplate="summary">
            {{ size }} results
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
